export enum IntegrationsId {
  APS = 'cd7c0e6d-37a6-4c04-a03e-db10d23cd238',
  LEGADMI = '4ca22799-234b-41d3-8c1e-71f7312caff7',
  LEGADMI_PANAMA = 'dd3d6039-aa52-45de-bad6-c1511240ef64',
  DESIGNER = '55c4fdfc-ad54-4a16-9b1c-54a87fc1d727',
  MANUAL = '41520755-8eaa-4907-b8ae-ac9668748cc7',
}

/** Manual payrolls have no payroll system: employee data is maintained from AUT. */
export const isManualIntegration = (integrationTypeId?: string | null) =>
  integrationTypeId === IntegrationsId.MANUAL

// Modules available on manual payrolls (first phase: profile and vacations)
export const MANUAL_INTEGRATION_MODULE_IDS = [
  'd59b9a36-9e50-42db-9e2e-0b6cd0cc3af6', // Perfil
  '4cd668a4-796d-42b4-9212-dcae903f299b', // Vacaciones
]
